import { Component, OnInit } from '@angular/core';
import { CtbCsdService } from '../ctb-csd.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../login/login.service';
import Swal from 'sweetalert2';
declare var $: any;
@Component({
  selector: 'app-contabilidad-electronica-csd-lista',
  templateUrl: './contabilidad-electronica-csd-lista.component.html',
  styleUrls: ['./contabilidad-electronica-csd-lista.component.css']
})
export class ContabilidadElectronicaCsdListaComponent implements OnInit {
  private dto: any = { envio: false, timbrado: false, key_clave: '' };
  public lista_csd: any[] = [{keyClave: ''}];
  private csd_temporal: any = {};
  public id_param: number;
  public csd_indice_modificar = 0;
  private nuevo: boolean;
  public statusSubida: boolean;
  private porcentaje: number;
  public cer: File;
  public key: File;
  fecha_actual: String;

  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    private csdService: CtbCsdService, public loginService: LoginService) { }

  ngOnInit(): void {
    const dateObj = new Date();
    const month = dateObj.getUTCMonth() + 1; // months from 1-12.
    const day = dateObj.getUTCDate();
    const year = dateObj.getUTCFullYear();
    this.fecha_actual = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    this.statusSubida = false;
    this.dto.envio = false;
    this.dto.timbrado = false;
    this.dto.fiel_o_sello = 1;
    this.activatedRoute.params.subscribe(params => {
      this.id_param = params['id'];
      if (this.id_param) {
        this.cargarRegistros();
      }
    });
  }

  isLater(dateString1, dateString2) {
  return dateString1 > dateString2;
}
  eliminarRegistro(indice: number) {
    Swal.fire({
      title: 'Eliminar',
      text: `¿Está seguro de eliminar este elemento?`,
      showCancelButton: true,
      confirmButtonText: 'Eliminar'
    }).then((result) => {
      if (result.value) {
        this.csdService.delete(this.lista_csd[indice].id).subscribe(response => {
          this.lista_csd.splice(indice, 1);
          Swal.fire('Mensaje', response.mensaje, 'success');
        }, err => {
          if (err.error.mensaje == null) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire({
            icon: 'error',
            title: 'Mensaje',
            text: err.error.mensaje
          })
          console.log(err);
        });
      }
    });
  }

  seleccionarCer(event) {
    this.cer = event.target.files[0];
    this.lista_csd[this.csd_indice_modificar].cerNombre = this.cer.name;
    var reader = new FileReader();
    reader.readAsDataURL(this.cer);
    reader.onloadend = (e) => {
      this.lista_csd[this.csd_indice_modificar].cerArchivo = reader.result.toString();
      console.log(this.lista_csd[this.csd_indice_modificar]);
    };
  }

  descargarCer(id: number, index: number) {
    this.csdService.getCer(id).subscribe(
      response => {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(response);
        a.download = this.lista_csd[index].cerNombre;
        document.body.appendChild(a);
        a.click();
      }
    );
  }
  descargarKey(id: number, index: number) {
    this.csdService.getKey(id).subscribe(
      response => {
        console.log(response)
        const a = document.createElement('a');
        a.href = URL.createObjectURL(response);
        a.download = this.lista_csd[index].keyNombre;
        document.body.appendChild(a);
        a.click();
      }
    );
  }
  async delay(ms: number) {
    await new Promise(resolve => setTimeout(() => resolve(), ms)).then(() => console.log("fired"));
  }
  subirCerKey(id: number) {
    this.csdService.postCerKey(this.cer, this.key, id).subscribe(
      response => {
        this.key = null;
        this.cer = null;
        this.porcentaje = 100;
        this.showNotification('top', 'center', 'Cambio subido con éxito');
        this.cargarRegistros();
        this.statusSubida = false;
      }, err => {
        console.log(err);
        this.showNotification('top', 'center', err.mensaje);
        this.statusSubida = false;
        this.porcentaje = 0;
      }
    );
  }

  seleccionarKey(event) {
    this.key = event.target.files[0];
    this.lista_csd[this.csd_indice_modificar].keyNombre = this.key.name;
    var reader = new FileReader();
    reader.readAsDataURL(this.key);
    reader.onloadend = (e) => {
      this.lista_csd[this.csd_indice_modificar].keyArchivo = reader.result.toString();
      console.log(this.lista_csd[this.csd_indice_modificar]);
    };
  }

  subirArchivos(id: number) {
    this.subirCerKey(id);
  }
  wait(milisenconds: number) {
    return new Promise<number>(resolve => {
      setTimeout(() => {
        resolve(1);
      }, milisenconds);
    });
  }
  async asyncMethod() {
    this.statusSubida = true;
    this.porcentaje = 0;
    for (let x = 0; x < 80; x++) {
      const value = await this.wait(250);
      if (this.porcentaje < 100) {
        this.porcentaje += value;
      }
    }
  }
  cargarRegistros() {
    this.csdService.get(this.id_param).subscribe(response => {
      this.lista_csd = response.contenido;
      console.log(this.lista_csd);
      this.csd_indice_modificar = 0;
      this.porcentaje = 100;
    }, err => {
      if (err.error.mensaje == null) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'Mensaje',
        text: err.error.mensaje
      })
      console.log(err);
    });
  }
  nuevoRegistro() {
    this.nuevo = true;
    this.lista_csd.push({ gralEmpId: this.id_param, fiel_o_sello: 1 });
    this.csd_indice_modificar = this.lista_csd.length - 1;
  }
  abrirRegistroLista(item: any, i: number) {
    this.csd_indice_modificar = i;
    this.csd_temporal = item;
  }
  public asignarCerArchivo(files: any[]) {
    if (files && files.length > 0) {
      const file = files[0];
      this.lista_csd[this.csd_indice_modificar].cerNombre = file.name;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.lista_csd[this.csd_indice_modificar].cerArchivo = reader.result;
      };
    }
  }
  public asignarKeyArchivo(files: any[]) {
    if (files && files.length > 0) {
      const file = files[0];
      this.lista_csd[this.csd_indice_modificar].keyNombre = file.name;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.lista_csd[this.csd_indice_modificar].keyArchivo = reader.result;
      };
    }
  }
  toggleTimbrado() {
    if (this.lista_csd[this.csd_indice_modificar].timbrado == true) {
      this.lista_csd[this.csd_indice_modificar].timbrado = false;
    } else {
      this.lista_csd[this.csd_indice_modificar].timbrado = true;
    }
  }
  toggleEnvio() {
    if (this.lista_csd[this.csd_indice_modificar].envio == true) {
      this.lista_csd[this.csd_indice_modificar].envio = false;
    } else {
      this.lista_csd[this.csd_indice_modificar].envio = true;
    }
  }
  guardarRegistro() {
    if (this.cer == null) {
      this.showNotification('top', 'center', 'Debes seleccionar un archivo CER');
    }
    if (this.key == null) {
      this.showNotification('top', 'center', 'Debes seleccionar un archivo KEY');
    }
    if (this.cer != null && this.key != null) {
      this.asyncMethod();
      console.log(this.lista_csd[this.csd_indice_modificar]);
      this.csdService.post(this.lista_csd[this.csd_indice_modificar]).subscribe(response => {
        this.lista_csd[this.csd_indice_modificar] = response.contenido;
        this.porcentaje = 100;
        this.showNotification('top', 'center', 'Cambio subido con éxito');
        this.cargarRegistros();
        this.statusSubida = false;
        this.router.navigate(['/contabilidad/catalogo/ctb-csd-conf']);
      }, err => {
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        this.statusSubida = false;
        this.porcentaje = 0;
        Swal.fire('Mensaje', err.error.mensaje, 'error');
      });
    }
  }
  cancelarCambios() {
    if (this.nuevo == true) {
      this.lista_csd.splice(this.csd_indice_modificar, 1);
    } else {
      this.lista_csd[this.csd_indice_modificar] = this.csd_temporal;
    }
    this.nuevo = false;
  }
  showNotification(from: any, align: any, message: String) {
    const type = ['', 'info', 'success', 'warning', 'danger'];

    const color = Math.floor((Math.random() * 4) + 1);
    $.notify({
      icon: 'pe-7s-info',
      message: message
    }, {
        type: type[color],
        timer: 1000,
        placement: {
          from: from,
          align: align
        }
      });
  }

}
